var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-6"},_vm._l((_vm.fontSizes),function([prop, value]){return _c('div',{key:prop},[_c('p',{staticClass:"mb-2 leading-none text-gray-900 dark:text-gray-500",style:({
        fontSize: _vm.getFontSizeValue(value)
      })},[_vm._v("\n      "+_vm._s(_vm.data.typographyExample)+"\n    ")]),_c('CanvasBlockLabel',{attrs:{"label":`text-${prop}`,"value":_vm.getFontSizeValue(value)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }